import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    Grid,
    Theme,
    Typography,
    useTheme,
} from '@mui/material';
import { Form, Formik, FormikErrors, FormikHelpers, useFormikContext } from 'formik';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import { FormControl } from '@mui/material';
import { showError } from '../../redux-store/actions/auth';
import MFCheckbox from '../../lib/formik/Checkbox';
import UseRadioGroup, { UseRadioGroupTransparent } from '../../lib/formik/Radio';
import { MFSubmitButton, MFTextField } from '../../lib/formik';
import { useHistory, useParams } from 'react-router';
// import { riskProfileScheme } from '../../utils/schema';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
    EditRiskProfileRes,
    LastEditedRiskProfile,
    profileType,
    RiskProfile,
    RiskProfileGroup,
    RiskProfileMaster,
    RiskProfileMasterType,
} from '../../redux-store/types/api-types';
import { RootStateType } from '../../redux-store/reducers';
import {
    applicationComparison,
    applyRoleBasedStatus,
    fetchRiskProfileGroupKey,
    findRiskTolerance,
    getAge,
    getRiskAgeValue,
    getScore,
    saveForLater,
} from '../../utils/utilityFunctions';
import { updateApplication } from '../../redux-store/actions/application';
import { AMC_APPROVER_CHECK_FOR_INDIVIDUAL, APPLICATION_TYPE } from '../../utils/constant';
import { useSnackbar } from 'notistack';
import { getEditRiskProfile, getLastEditedRiskProfile, getRiskProfileGroups, riskProfileMasterData } from '../../redux-store/actions';
import { riskProfileDeclaration, riskProfileDonotWish } from '../../utils/declaration';
import { fontSize } from '@mui/system';
import { ConfirmationDialog } from '../commonComponents';
import theme from '../../themes';
import MFSelectField from '../../lib/formik/SelectField';
import { TextDatePicker } from '../onboarding/DatePickerWithTextFeild';
import dayjs, { Dayjs } from "dayjs";
import { ProceedSaveLater } from '../investors/components';
import { LoadingButton } from '@mui/lab';
import BreadCrum from '../../lib/BreadCrum';
import { DayJsDatePicker } from '../onboarding/newDatePicker';
import { set } from 'lodash';
import { FailureIcon, SuccessIcon } from '../../assets/SvgIcons';

export type updatedRiskProfile = RiskProfile &
    RiskProfileMasterType & {
        otherValue?: string;
        InvestmentGoal?: string[];
        scoreCal?: number;
        answerText?: string;
        questionText?: string;
    };

export type Values = {
    wishToAddRiskProfile: boolean;
    riskProfileDeclaration: boolean;
    riskProfileGroup?: string;
    riskProfileDeclarationDate?: Dayjs;
    riskProfileExpiryDate?: Dayjs;
    totalRiskProfileScore: number;
    riskprofiles: updatedRiskProfile[];
    saveType: string;
    riskProfile?: string;
};

export const RiskProfileObj: updatedRiskProfile = {
    question: '',
    answer: '',
    scoreText: '',
    otherValue: '',
    key: '',
    displayText: '',
    InvestmentGoal: [],
    scoreCal: 0,
    answerText: '',
    questionText: ''
};

const todayDate = new Date();

const initialValues: Values = {
    wishToAddRiskProfile: false,
    riskProfileDeclaration: true,
    riskProfileGroup: "",
    riskProfileDeclarationDate: dayjs(),
    riskProfileExpiryDate: dayjs(),
    totalRiskProfileScore: 0,
    riskprofiles: [],
    riskProfile: '',
    saveType: 'save and proceed',
};


function RiskDeclaration({
    data,
    values,
    setValues,
    setTotalScore,
    totalScore,
    disabled,
}: {
    data: updatedRiskProfile[];
    values: Values;
    setValues: FormikHelpers<Values>['setValues'];
    setTotalScore: any;
    totalScore: any;
    disabled: boolean;
}): JSX.Element {
    const [expanded, setExpanded] = React.useState<string | false>('');

    useEffect(() => {
        setExpanded(disabled ? '' : expanded);
    }, [disabled]);

    const _handleSelection = async (
        ind: number,
        selectedOptionObj: any,
        InvestmentGoal: string[],
        scoreCal: string | number
    ) => {
        const index = InvestmentGoal?.indexOf(
            `${selectedOptionObj.key}_${selectedOptionObj.score}` as string
        );
        const investmentGoalSelect =
            index === -1
                ? [...InvestmentGoal, `${selectedOptionObj.key}_${selectedOptionObj.score}`]
                : InvestmentGoal?.filter(
                    (goal: any) => goal != (`${selectedOptionObj.key}_${selectedOptionObj.score}` as string)
                );

        const total = investmentGoalSelect?.includes(
            `${selectedOptionObj.key}_${selectedOptionObj.score}`
        )
            ? Number(scoreCal) + Number(selectedOptionObj.score)
            : Number(scoreCal) - Number(selectedOptionObj.score);

        setValues({
            ...values,
            riskprofiles: values.riskprofiles.map((risk, index) => {
                if (index === ind) {
                    return {
                        ...risk,
                        answer: investmentGoalSelect?.toString().replace(/,/g, '*'),
                        scoreText: total.toFixed(1)?.toString() || '',
                        InvestmentGoal: investmentGoalSelect,
                        scoreCal: total,
                    };
                }
                return risk;
            }),
        });
    };

    const handleChange = (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
        setExpanded(newExpanded ? panel : false);
    };
    return (
        <Box sx={{ width: '100%' }}>
            {data?.map((dataValues: any, ind: any) => {
                return (
                    <>
                        <Accordion
                            sx={{ boxShadow: 'none', mb: 3, '&::before': { display: 'none' } }}
                            key={ind}
                            expanded={expanded === `panel${ind}`}
                            onChange={handleChange(`panel${ind}`)}
                            disabled={disabled}>
                            <AccordionSummary
                                sx={{
                                    bgcolor: `${theme.palette.primary[50]}`,
                                    borderRadius: '10px',
                                    '&.Mui-expanded': { minHeight: 'unset' },
                                    '& .MuiAccordionSummary-content': { '&.Mui-expanded': { my: 2 } },
                                }}
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls={`panel${ind}d-content`}
                                id={`panel${ind}d-header`}>
                                <Typography
                                    sx={{
                                        color: `${theme.palette.text.primary}`,
                                        fontSize: 16,
                                        fontWeight: 500,
                                        fontFamily: `${theme.typography.fontFamily}`
                                    }}>
                                    {`${ind + 1}. ${dataValues.displayText} ${dataValues.required === 'true' ? '*' : ''
                                        }`}
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails sx={{ pb: 0 }}>
                                {['radio', 'multiSelectCheckBox'].includes(dataValues.questionType) && (
                                    <>
                                        {dataValues.isMultiselect === 'false' && (
                                            <UseRadioGroupTransparent
                                                name={`riskprofiles.${ind}.answer`}
                                                items={dataValues.values.map((profile: any) => ({
                                                    label: profile.label,
                                                    value: profile.key,
                                                }))}
                                                onChange={(e) => {
                                                    let score;
                                                    setValues({
                                                        ...values,
                                                        riskprofiles: values.riskprofiles.map((risk, index) => {
                                                            if (index === ind) {
                                                                score = risk.values?.filter((risk) => {
                                                                    return risk.key === e.target.value;
                                                                })?.[0].score;
                                                                setTotalScore(totalScore + Number(score));
                                                                return {
                                                                    ...risk,
                                                                    answer: e.target.value,
                                                                    scoreText: score?.toString() || '',
                                                                    answerText: dataValues?.values?.find((obj: { [key: string]: any }) => obj?.key === e.target.value)?.label ?? ""
                                                                };
                                                            }
                                                            return risk;
                                                        }),
                                                    });
                                                }}
                                                sx={{
                                                    '& .MuiFormGroup-root': { flexDirection: 'column' },
                                                    '& .MuiFormControlLabel-label': { fontWeight: 400 },
                                                }}
                                            />
                                        )}
                                        {dataValues.isMultiselect === 'true' &&
                                            dataValues.values.map((risk: any) => {
                                                return (
                                                    <>
                                                        <FormControlLabel
                                                            key={dataValues.key}
                                                            value={dataValues.key}
                                                            sx={{
                                                                width: '100%',
                                                                position: 'relative',
                                                                pb: 0,
                                                                ml: 0.2,
                                                                '.MuiFormLabel-root ': {
                                                                    color: 'primary.main',
                                                                    fontWeight: 600,
                                                                    mb: 0.5,
                                                                },
                                                                '.MuiFormControlLabel-root': {
                                                                    width: '100%',
                                                                    alignItems: 'flex-start',
                                                                    '.MuiTypography-root': {
                                                                        color: 'text.primary',
                                                                        fontWeight: 500,
                                                                        fontSize: 14,
                                                                        overflow: { xs: 'unset', md: 'hidden' },
                                                                        whiteSpace: { xs: 'unset', md: 'nowrap' },
                                                                        textOverflow: { xs: 'unset', md: 'ellipsis' },
                                                                        wordBreak: { xs: 'break-word', md: 'unset' },
                                                                    },
                                                                    '.MuiRadio-root,.MuiCheckbox-root ,.Mui-checked': {
                                                                        color: 'text.primary',
                                                                    },
                                                                    '.MuiRadio-root,.MuiCheckbox-root ': { p: 0, mr: 0.5 },
                                                                },
                                                                '.MuiAccordionDetails-root': {
                                                                    paddingTop: 0,
                                                                },
                                                                '.MuiAccordionSummary-content.Mui-expanded': {
                                                                    marginBottom: '10px',
                                                                },
                                                            }}
                                                            onChange={() => {
                                                                _handleSelection(
                                                                    ind,
                                                                    risk,
                                                                    dataValues.InvestmentGoal,
                                                                    dataValues.scoreCal
                                                                );
                                                            }}
                                                            control={
                                                                <Checkbox
                                                                    size="small"
                                                                    checked={dataValues.InvestmentGoal?.map((goal: any) =>
                                                                        goal.toString()
                                                                    ).includes(`${risk.key}_${risk.score}`)}
                                                                />
                                                            }
                                                            label={risk.label}
                                                            title={risk.label}
                                                        />
                                                    </>
                                                );
                                            })}
                                    </>
                                )}
                                {(`${values.riskprofiles[ind]?.answer ?? ''}`.toLowerCase() === 'others' ||
                                    (values.riskprofiles[ind].isMultiselect === 'true' &&
                                        values.riskprofiles[ind]?.answer.includes('others'))) && (
                                        <Grid xs={12} sm={6}>
                                            <MFTextField
                                                name={`riskprofiles.${ind}.otherValue`}
                                                placeholder={`Please specify`}
                                                sx={{
                                                    mb: 0,
                                                    '&.MuiInputBase-root': {
                                                        position: 'relative',
                                                        border: 0,
                                                        borderBottom: '1px solid #DDEAF3',
                                                        fontSize: 16,
                                                    },
                                                }}
                                                onChange={(e) => {
                                                    const removeAstricOrUnderscore = e.target.value
                                                        ?.replace('*', '')
                                                        ?.replace('_', '');
                                                    setValues({
                                                        ...values,
                                                        riskprofiles: values.riskprofiles.map((risk, index) => {
                                                            if (index === ind) {
                                                                return {
                                                                    ...risk,
                                                                    otherValue: removeAstricOrUnderscore,
                                                                };
                                                            }
                                                            return risk;
                                                        }),
                                                    });
                                                }}
                                            />
                                        </Grid>
                                    )}
                            </AccordionDetails>
                        </Accordion>
                    </>
                );
            })}
        </Box>
    );
}

export const profiletext = (total: number, profileData: profileType[]): any => {
    let text;
    profileData?.map((profile) => {
        const min = Math.min(profile.minScore, profile.maxScore);
        const max = Math.max(profile.minScore, profile.maxScore);
        if (total >= min && total <= max) {
            text = (
                <>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Typography sx={{ fontFamily: `${theme.typography.fontFamily}`, fontSize: 16, fontWeight: 500, color: '#FFF', pr: 1 }}>
                            {`Risk profile :`}
                        </Typography>
                        <Typography sx={{ fontFamily: `${theme.typography.fontFamily}`, fontSize: 18, fontWeight: 700, color: '#FFF' }}>
                            {`${profile?.profileName}`}

                        </Typography>

                    </Box>
                </>
            );
        }
    });
    return text;
};

export const handleIntialSelect = (riskprofiles: RiskProfile[], riskProfileQuestion: string) => {
    let selectedValue: string[] = [];
    const longTermArr = riskprofiles?.find((a) => a.question === riskProfileQuestion);
    selectedValue = longTermArr?.answer.split('*') as unknown as string[];
    return selectedValue;
};

const isDateInRange = (dateToCheck: Dayjs, lowerLimit: Dayjs, upperLimit: Dayjs) => {
    return (
        dateToCheck.isSame(lowerLimit, 'day') ||
        dateToCheck.isSame(upperLimit, 'day') ||
        (dateToCheck.isAfter(lowerLimit, 'day') && dateToCheck.isBefore(upperLimit, 'day'))
    );
}

export default function EditRiskProfile({ onClose }: { onClose: () => void }): JSX.Element {
    const history = useHistory();
    const { pathname: pathName, state } = history.location;
    const clientCode = ((state as any)?.clientCode ?? '') as string;
    const theme = useTheme();
    const [riskProfileData, setRiskProfileData] = useState<Values>(initialValues);
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const { application } = useSelector((store: RootStateType) => store.application);
    const { role = '' } = useSelector((store: RootStateType) => store.auth);
    const { applicationId: investorApplicationId = '' } = useSelector((store: RootStateType) => store.id);
    const { enqueueSnackbar } = useSnackbar();
    const [riskProfileDataMaster, setRiskProfileDataMaster] = useState<RiskProfileMasterType[]>([]);
    const [profileData, setProfileData] = useState<profileType[]>([]);
    const [totalScore, setTotalScore] = useState(0);
    const [openPopup, setOpenPopup] = useState<{ riskProfileCheck: boolean } | null>(null);
    const [questionSetList, setQuestionSetList] = useState<RiskProfileGroup[]>([])
    const [isApiLoading, setApiLoading] = useState<boolean>(false)
    const [id, setId] = useState<string>('');
    const [editLoading, setEditLoading] = useState<boolean>(false);
    const [lastEditedRiskProfileData, setLastEditedRiskProfileData] = useState<LastEditedRiskProfile>({})
    const [isSuccessDialogOpen, setSuccessDialogOpen] = useState<boolean>(false)
    const [isErrorDialogOpen, setErrorDialogOpen] = useState<boolean>(false)

    // const navState = state as dashBoardNavigation


    const handleSubmit = async (values: any) => {
        const payload = {
            wishToAddRiskProfile: values.wishToAddRiskProfile,
            riskProfiles: values.riskprofiles,
            applicationId: id,
            riskProfileGroup: values.riskProfileGroup,
            riskProfileDeclarationDate: !values.wishToAddRiskProfile ? null : values.riskProfileDeclarationDate,
            riskProfileExpiryDate: !values.wishToAddRiskProfile ? null : values.riskProfileExpiryDate,
            company: lastEditedRiskProfileData.company,
        }

        const wishToAddRiskProfile = values.wishToAddRiskProfile;
        const riskProfileDeclaration = values.riskProfileDeclaration

        try {
            setEditLoading(true)

            const checkAllQuestionsAnswered = values.riskprofiles
                ?.map((profile: any) => profile.answer !== '' && profile.required === 'true')
                ?.every((_profile: any) => _profile);


            if (wishToAddRiskProfile && !checkAllQuestionsAnswered) {
                throw 'Please fill all the required(*) fields';
            }
            if (wishToAddRiskProfile && !values.riskProfileGroup) {
                throw 'Please select a Question Set'
            }
            if (wishToAddRiskProfile && !values.riskProfileDeclarationDate) {
                throw 'Declaration date is required'
            }
            if (wishToAddRiskProfile && !isDateInRange(values.riskProfileDeclarationDate ?? dayjs(), dayjs("1900-01-01"), dayjs())) {
                throw "Declaration date should be less than or equal to today's date"
            }
            // if (wishToAddRiskProfile && !values.riskProfileExpiryDate) {
            //     throw 'Expiry date is required'
            // }
            // if (wishToAddRiskProfile && !isDateInRange(values.riskProfileExpiryDate ?? dayjs(), dayjs(), dayjs("2099-12-31"))) {
            //     throw "Expiry date should be greater than or equal to today's date"
            // }
            if (wishToAddRiskProfile && !riskProfileDeclaration) {
                throw 'Declaration is required';
            }

            const EditRiskProfileRes = (await dispatch(getEditRiskProfile(payload))) as unknown as EditRiskProfileRes

            if (EditRiskProfileRes?.isSuccess) {
                setSuccessDialogOpen(true)
            }
            if (!EditRiskProfileRes?.isSuccess) {
                setErrorDialogOpen(true)
            }
        } catch (e) {
            setEditLoading(false);
            typeof e === 'string' && dispatch(showError(e));
            console.error((e as Error).message);
        } finally {
            setEditLoading(false)
        }
    }

    const handleNonIndSubmit = async (values: any) => {
        try {
            const payload = {
                wishToAddRiskProfile: values.wishToAddRiskProfile,
                applicationId: id,
                riskProfileDeclarationDate: !values.wishToAddRiskProfile ? null : values.riskProfileDeclarationDate,
                riskProfile: values.riskProfile,
                company: lastEditedRiskProfileData.company
            }

            const wishToAddRiskProfile = values.wishToAddRiskProfile;
            const riskProfileDeclaration = values.riskProfileDeclaration;

            if (wishToAddRiskProfile && !values.riskProfileDeclarationDate) {
                throw 'Declaration date is required'
            }
            if (wishToAddRiskProfile && !isDateInRange(values.riskProfileDeclarationDate ?? dayjs(), dayjs("1900-01-01"), dayjs())) {
                throw "Declaration date should be less than or equal to today's date"
            }
            if (wishToAddRiskProfile && !riskProfileDeclaration) {
                throw 'Declaration is required';
            }
            if (!values.riskProfile) {
                throw 'Please select a Risk Profile'
            }
            const EditRiskProfileRes = (await dispatch(getEditRiskProfile(payload))) as unknown as EditRiskProfileRes
            if (EditRiskProfileRes?.isSuccess) {
                setSuccessDialogOpen(true)
            }
            if (!EditRiskProfileRes?.isSuccess) {
                setErrorDialogOpen(true)
            }
        } catch (e) {
            typeof e === 'string' && dispatch(showError(e));
            console.error((e as Error).message);
        }
    }

    useEffect(() => {
        let isComponentAlive = true;
        (async function () {
            try {

                setApiLoading(true)

                const riskProfileGroupsResponse = (await dispatch(getRiskProfileGroups())) as unknown as RiskProfileGroup[];

                setQuestionSetList(riskProfileGroupsResponse ?? [])

                const lastEditedRiskProfileRes = (await dispatch(getLastEditedRiskProfile({ clientCode: clientCode, applicationId: investorApplicationId }))) as unknown as LastEditedRiskProfile

                setLastEditedRiskProfileData(lastEditedRiskProfileRes ?? {})

                const riskProfileGrp = lastEditedRiskProfileRes?.applicant?.riskProfileGroup ? lastEditedRiskProfileRes?.applicant?.riskProfileGroup : fetchRiskProfileGroupKey(riskProfileGroupsResponse, application?.applicationType ?? '');

                const company = lastEditedRiskProfileRes?.company;

                const applicationId = lastEditedRiskProfileRes?.id ?? '';

                const declarationDate = lastEditedRiskProfileRes?.applicant?.riskProfileDeclarationDate ? dayjs(lastEditedRiskProfileRes?.applicant?.riskProfileDeclarationDate) : dayjs(todayDate)

                const expiryDate = lastEditedRiskProfileRes?.applicant?.riskProfileExpiryDate ? dayjs(lastEditedRiskProfileRes?.applicant?.riskProfileExpiryDate) : dayjs(todayDate)
                setId(`${applicationId}`)


                const response = (await dispatch(riskProfileMasterData({
                    // riskProfileGroup: application?.riskProfileGroup ? application?.riskProfileGroup : riskProfileGroupsResponse?.[0]?.key ?? null,
                    // company: application?.company ?? null
                    riskProfileGroup: riskProfileGrp ?? null,
                    company: company ?? null
                }))) as unknown as RiskProfileMaster;
                if (!isComponentAlive) {
                    return;
                }
                setRiskProfileDataMaster(response.riskProfile);
                setProfileData(response.profile);
                // const {
                //     riskprofiles = [],
                //     riskProfileDeclaration = true,
                //     wishToAddRiskProfile = true,
                // } = application || {};

                const {
                    riskProfiles: riskprofiles = [],
                    riskProfileDeclaration = true,
                    wishToAddRiskProfile = true,
                    riskProfile
                } = lastEditedRiskProfileRes?.applicant || {};
                setRiskProfileData({
                    ...riskProfileData,
                    wishToAddRiskProfile: wishToAddRiskProfile || false,
                    riskProfileDeclaration: wishToAddRiskProfile ? false : riskProfileDeclaration || true,
                    riskProfileGroup: riskProfileGrp,
                    riskProfileDeclarationDate: declarationDate,
                    riskProfileExpiryDate: expiryDate,
                    riskprofiles: response.riskProfile
                        ?.map((mdmsProfile) => {
                            const existingRiskProfiles = riskprofiles?.filter(
                                (risk_profiles: updatedRiskProfile) => risk_profiles.question === mdmsProfile.key
                            );
                            return existingRiskProfiles.length
                                ? existingRiskProfiles?.map((existingProfiles: updatedRiskProfile) => {
                                    if (
                                        existingProfiles.question === mdmsProfile.key &&
                                        mdmsProfile.isMultiselect === 'true'
                                    ) {
                                        const getInvestment = handleIntialSelect(riskprofiles, mdmsProfile.key);
                                        const checkAnswerArray = mdmsProfile.values?.map((_value) => _value.key);
                                        let getOtherValue = '';
                                        const updateOptions = getInvestment.map((ans) => {
                                            if (!checkAnswerArray?.includes(ans.split('_')[0])) {
                                                getOtherValue = ans.split('_')[0];
                                                return `others_${ans.split('_')[1]}`;
                                            }
                                            return ans;
                                        });
                                        return {
                                            ...existingProfiles,
                                            ...mdmsProfile,
                                            values: mdmsProfile.values?.map((value) => {
                                                const scoreUpdate = updateOptions
                                                    .find((investment) => investment?.split('_')[0] === value.key)
                                                    ?.split('_')[1];

                                                return {
                                                    ...value,
                                                    score: scoreUpdate ? Number(scoreUpdate) : value.score,
                                                };
                                            }),
                                            InvestmentGoal: updateOptions || [],
                                            scoreCal: Number(existingProfiles.scoreText) || 0,
                                            otherValue: getOtherValue,
                                            answer: getOtherValue
                                                ? updateOptions?.toString()?.replace(/,/g, '*')
                                                : existingProfiles.answer,
                                            questionText: mdmsProfile?.displayText ?? "",
                                            answerText: mdmsProfile?.values?.find((obj: { [key: string]: any }) => obj?.key === existingProfiles?.answer)?.label ?? ""
                                        };
                                    } else {
                                        const checkAnswer =
                                            existingProfiles.question === mdmsProfile.key &&
                                            mdmsProfile.isMultiselect === 'false' &&
                                            mdmsProfile.values
                                                ?.map((value) => value.key)
                                                .includes(existingProfiles.answer);

                                        return {
                                            ...existingProfiles,
                                            ...mdmsProfile,
                                            values: mdmsProfile.values?.map((value) => {
                                                if (existingProfiles.answer === value.key) {
                                                    return {
                                                        ...value,
                                                        score: Number(existingProfiles.scoreText),
                                                    };
                                                }
                                                return value;
                                            }),
                                            otherValue: checkAnswer ? '' : existingProfiles.answer,
                                            answer: checkAnswer ? existingProfiles.answer : 'others',
                                            questionText: mdmsProfile?.displayText ?? "",
                                            answerText: mdmsProfile?.values?.find((obj: { [key: string]: any }) => obj?.key === existingProfiles?.answer)?.label ?? ""
                                        };
                                    }
                                })
                                : [
                                    {
                                        ...RiskProfileObj,
                                        question: mdmsProfile.key,
                                        answer:
                                            wishToAddRiskProfile === null && mdmsProfile.key === 'age'
                                                ? getRiskAgeValue(
                                                    getAge(
                                                        application?.applicants?.find(
                                                            (_applicant) => _applicant.applicant_type === '1'
                                                        )?.dateOfBirth
                                                    )
                                                )
                                                : '',
                                        scoreText:
                                            wishToAddRiskProfile === null && mdmsProfile.key === 'age'
                                                ? getScore(
                                                    getRiskAgeValue(
                                                        getAge(
                                                            application?.applicants?.find(
                                                                (_applicant) => _applicant.applicant_type === '1'
                                                            )?.dateOfBirth
                                                        )
                                                    )
                                                )
                                                : '',
                                        ...mdmsProfile,
                                        questionText: mdmsProfile?.displayText ?? ""
                                    },
                                ];
                        })
                        .flat(),
                    riskProfile: riskProfile
                });

            } catch (e) {
                console.error((e as Error).message);
            } finally {
                setApiLoading(false)
            }
        })();
        return () => {
            isComponentAlive = false;
        };
    }, []);

    const manageTotal = (values: Values) => {
        const total = values.riskprofiles
            .map((risk) => {
                return Number(risk.scoreText);
            })
            .reduce(function (acc, val) {
                return acc + val;
            }, 0);

        return total;
    };

    const getLatestRiskProfile = async (
        setFieldValue: (field: string, value: any, shouldValidate?: boolean) => Promise<void | FormikErrors<Values>>, selectedRiskProfileGroup: string) => {
        try {
            setApiLoading(true)

            setFieldValue('riskProfileGroup', selectedRiskProfileGroup);

            const response = (await dispatch(riskProfileMasterData({
                riskProfileGroup: selectedRiskProfileGroup ?? null,
                company: lastEditedRiskProfileData?.company
            }))) as unknown as RiskProfileMaster;

            setRiskProfileDataMaster(response.riskProfile);
            setProfileData(response.profile);

            const {
                riskprofiles = [],
                wishToAddRiskProfile = true,
                riskProfileGroup
            } = application?.applicants[0] || {};

            setFieldValue("riskprofiles", response?.riskProfile
                ?.map((mdmsProfile) => {
                    let existingRiskProfiles: RiskProfile[] = []

                    if (riskProfileGroup === selectedRiskProfileGroup) {
                        existingRiskProfiles = riskprofiles?.filter(
                            (risk_profiles) => risk_profiles.question === mdmsProfile.key
                        );
                    }

                    return existingRiskProfiles.length
                        ? existingRiskProfiles?.map((existingProfiles) => {
                            if (
                                existingProfiles.question === mdmsProfile.key &&
                                mdmsProfile.isMultiselect === 'true'
                            ) {
                                const getInvestment = handleIntialSelect(riskprofiles, mdmsProfile.key);
                                const checkAnswerArray = mdmsProfile.values?.map((_value) => _value.key);
                                let getOtherValue = '';
                                const updateOptions = getInvestment.map((ans) => {
                                    if (!checkAnswerArray?.includes(ans.split('_')[0])) {
                                        getOtherValue = ans.split('_')[0];
                                        return `others_${ans.split('_')[1]}`;
                                    }
                                    return ans;
                                });
                                return {
                                    ...existingProfiles,
                                    ...mdmsProfile,
                                    values: mdmsProfile.values?.map((value) => {
                                        const scoreUpdate = updateOptions
                                            .find((investment) => investment?.split('_')[0] === value.key)
                                            ?.split('_')[1];

                                        return {
                                            ...value,
                                            score: scoreUpdate ? Number(scoreUpdate) : value.score,
                                        };
                                    }),
                                    InvestmentGoal: updateOptions || [],
                                    scoreCal: Number(existingProfiles.scoreText) || 0,
                                    otherValue: getOtherValue,
                                    answer: getOtherValue
                                        ? updateOptions?.toString()?.replace(/,/g, '*')
                                        : existingProfiles.answer,
                                    questionText: mdmsProfile?.displayText ?? "",
                                    answerText: mdmsProfile?.values?.find((obj: { [key: string]: any }) => obj?.key === existingProfiles?.answer)?.label ?? ""
                                };
                            } else {
                                const checkAnswer =
                                    existingProfiles.question === mdmsProfile.key &&
                                    mdmsProfile.isMultiselect === 'false' &&
                                    mdmsProfile.values
                                        ?.map((value) => value.key)
                                        .includes(existingProfiles.answer);

                                return {
                                    ...existingProfiles,
                                    ...mdmsProfile,
                                    values: mdmsProfile.values?.map((value) => {
                                        if (existingProfiles.answer === value.key) {
                                            return {
                                                ...value,
                                                score: Number(existingProfiles.scoreText),
                                            };
                                        }
                                        return value;
                                    }),
                                    otherValue: checkAnswer ? '' : existingProfiles.answer,
                                    answer: checkAnswer ? existingProfiles.answer : 'others',
                                    questionText: mdmsProfile?.displayText ?? "",
                                    answerText: mdmsProfile?.values?.find((obj: { [key: string]: any }) => obj?.key === existingProfiles?.answer)?.label ?? ""
                                };
                            }
                        })
                        : [
                            {
                                ...RiskProfileObj,
                                question: mdmsProfile.key,
                                answer:
                                    wishToAddRiskProfile === null && mdmsProfile.key === 'age'
                                        ? getRiskAgeValue(
                                            getAge(
                                                application?.applicants?.find(
                                                    (_applicant) => _applicant.applicant_type === '1'
                                                )?.dateOfBirth
                                            )
                                        )
                                        : '',
                                scoreText:
                                    wishToAddRiskProfile === null && mdmsProfile.key === 'age'
                                        ? getScore(
                                            getRiskAgeValue(
                                                getAge(
                                                    application?.applicants?.find(
                                                        (_applicant) => _applicant.applicant_type === '1'
                                                    )?.dateOfBirth
                                                )
                                            )
                                        )
                                        : '',
                                ...mdmsProfile,
                                questionText: mdmsProfile?.displayText ?? ""
                            },
                        ];
                })
                .flat())

        } catch (e) {
            console.error((e as Error).message);
        } finally {
            setApiLoading(false)
        }
    }

    const initialRouter = pathName.split('/').filter((item) => item !== '')

    // const routerPath = [
    //     {
    //         name: 'Dashboard',
    //         path: '/dashboard',
    //         state: {
    //             accountFilter: navState?.accountFilter,
    //         },
    //         handleClick: () => {
    //             dispatch(storeSelectedPortfolio({
    //                 label: '',
    //                 value: ''
    //             }))
    //             dispatch(storePortfolioList([]))
    //         }
    //     },
    //     {
    //         name: `${initialRouter[1]}`,
    //         path: `/${initialRouter[0]}/${initialRouter[1]}`,
    //         state: {
    //             clientCode: ![USER_ROLES.INVESTOR].includes(role) ? navState?.clientCode : investorClientId
    //         }
    //     },
    // ]

    const handleDateChange = (date: any, fieldName: string, setFieldValue: (field: string, value: any, shouldValidate?: boolean) => Promise<void | FormikErrors<Values>>) => {
        let modifiedDate = date;

        if (modifiedDate) {
            const currentTime = dayjs();

            modifiedDate = modifiedDate
                ?.hour(currentTime.hour())
                ?.minute(currentTime.minute())
                ?.second(currentTime.second())
        }

        setFieldValue(fieldName, modifiedDate)
    }

    const handleSuccessDialogClose = () => {
        history.goBack()
        setSuccessDialogOpen(false)
    }

    const handleErrorDialogClose = () => {
        setErrorDialogOpen(false)
    }

    return (
        <>
            <Box>
                <Typography
                    variant="h1"
                    sx={(theme: Theme) => ({
                        lineHeight: "32.5px",
                        color: theme.palette.text.primary
                    })}
                >
                    Edit Risk Profile
                </Typography>

                {/* <BreadCrum array={routerPath} /> */}

                <Box sx={(theme: Theme) => ({
                    borderRadius: "25px",
                    padding: "35px",
                    backgroundColor: theme.palette.common.white,
                    mt: 2
                })}>
                    <Formik
                        initialValues={riskProfileData}
                        // validationSchema={riskProfileScheme}
                        onSubmit={application?.applicationType === APPLICATION_TYPE.NON_INDIVIDUAL ? handleNonIndSubmit : handleSubmit}
                        enableReinitialize={true}>
                        {({ handleSubmit, values, setValues, setFieldValue }) => (
                            <Form>
                                <Grid
                                    container
                                    rowSpacing={0.5}
                                    columnSpacing={3}
                                // component="form"
                                // noValidate
                                // onSubmit={handleSubmit}
                                >
                                    <Grid item xs={12}>
                                        {/* <Grid xs={12} sx={{ mb: 2 }}>
                                            <MFCheckbox
                                                name="wishToAddRiskProfile"
                                                label={riskProfileDonotWish}
                                                sx={{ display: 'flex', alignItems: 'flex-start', fontFamily: `${theme.typography.fontFamily}` }}
                                                onChange={({ target: { checked } }) => {
                                                    const updatedRiskProfile = riskProfileDataMaster.map((mdmsProfile) => {
                                                        const riskObj = values.riskprofiles?.find(
                                                            (_profile) => _profile.key === mdmsProfile.key
                                                        );
                                                        return {
                                                            ...RiskProfileObj,
                                                            question: mdmsProfile.key,
                                                            ...riskObj,
                                                            answer:
                                                                mdmsProfile.key === 'age'
                                                                    ? getRiskAgeValue(
                                                                        getAge(
                                                                            application?.applicants?.find(
                                                                                (_applicant) => _applicant.applicant_type === '1'
                                                                            )?.dateOfBirth
                                                                        )
                                                                    )
                                                                    : '',
                                                            scoreText:
                                                                mdmsProfile.key === 'age'
                                                                    ? getScore(
                                                                        getRiskAgeValue(
                                                                            getAge(
                                                                                application?.applicants?.find(
                                                                                    (_applicant) => _applicant.applicant_type === '1'
                                                                                )?.dateOfBirth
                                                                            )
                                                                        )
                                                                    )
                                                                    : '',
                                                            ...mdmsProfile,
                                                        };
                                                    });
                                                    !checked &&
                                                        setValues({
                                                            ...values,
                                                            wishToAddRiskProfile: checked,
                                                            riskProfileDeclaration: values.riskProfileDeclaration || true,
                                                            riskprofiles: [...updatedRiskProfile],
                                                        });
                                                    checked && setOpenPopup({ riskProfileCheck: checked });
                                                }}
                                                checked={values.wishToAddRiskProfile}
                                                disabled={isApiLoading}
                                            />
                                        </Grid> */}

                                        <Grid
                                            container
                                            spacing={2}
                                            sx={{
                                                marginBottom: 2,
                                                alignItems: "center",
                                            }}
                                        >
                                            {/* <Grid
                                                item
                                                xs={12}
                                                lg={4}
                                            >
                                                <MFSelectField
                                                    name="riskProfileGroup"
                                                    label="Question Set *"
                                                    items={questionSetList?.map(({ key, value }) => ({
                                                        key,
                                                        value
                                                    }))}
                                                    sx={{
                                                        "&.MuiOutlinedInput-root": {
                                                            "& fieldset>legend": {
                                                                fontSize: "0.78em",
                                                            }
                                                        }
                                                    }}
                                                    disabled={isApiLoading || !values.wishToAddRiskProfile}
                                                    onChange={(event) => {
                                                        getLatestRiskProfile(setFieldValue, `${event.target.value}`)
                                                    }}
                                                />
                                            </Grid> */}
                                            <Grid
                                                item
                                                xs={12}
                                                lg={4}
                                            >
                                                <TextDatePicker
                                                    name="riskProfileDeclarationDate"
                                                    label="Declaration Date *"
                                                    inputLabelStyles={{
                                                        transform: 'unset',
                                                        fontSize: 14,
                                                        fontWeight: 500,
                                                        color: `${theme.palette.text.primary}80`,
                                                    }}
                                                    placeholder=''
                                                    disabled={isApiLoading || !values.wishToAddRiskProfile}
                                                    customHandleChange={(date: any) => handleDateChange(date, "riskProfileDeclarationDate", setFieldValue)}
                                                />
                                                {/* <DayJsDatePicker
                                                            id=""
                                                            name='riskProfileDeclarationDate'
                                                            label="Declaration Date *"
                                                            disabled={isApiLoading || !values.wishToAddRiskProfile}
                                                            maxDate={todayDate}
                                                        /> */}
                                            </Grid>
                                            {/* <Grid
                                                item
                                                xs={12}
                                                lg={4}
                                            >
                                                <TextDatePicker
                                                    name="riskProfileExpiryDate"
                                                    label="Expiration Date *"
                                                    inputLabelStyles={{
                                                        transform: 'unset',
                                                        fontSize: 14,
                                                        fontWeight: 500,
                                                        color: 'rgba(0,0,0,0.7)',
                                                    }}
                                                    placeholder=''
                                                    disabled={isApiLoading || !values.wishToAddRiskProfile}
                                                    minDate={todayDate}
                                                    maxDate={new Date("2099-12-31")}
                                                    customHandleChange={(date: unknown) => handleDateChange(date, "riskProfileExpiryDate", setFieldValue)}
                                                />
                                                <DayJsDatePicker
                                                            id=""
                                                            name='riskProfileExpiryDate'
                                                            label="Expiration Date *"
                                                            disabled={isApiLoading || values.wishToAddRiskProfile}
                                                            minDate={todayDate}
                                                            maxDate={new Date("2099-12-31")}
                                                        />
                                            </Grid> */}
                                            {/* we are checking if the investor is nonindividual we are showing dropdown  */}
                                            {application?.applicationType === APPLICATION_TYPE.NON_INDIVIDUAL ? (<Grid
                                                item
                                                xs={12}
                                            >
                                                <MFSelectField
                                                    name="riskProfile"
                                                    label="Risk Profile*"
                                                    items={profileData.map((val: any) => ({
                                                        key: val?.profileName,
                                                        value: val?.profileName,
                                                    }))}
                                                    disabled={isApiLoading}
                                                    loading={isApiLoading}
                                                />
                                            </Grid>) :
                                                (<>
                                                    <RiskDeclaration
                                                        data={values.riskprofiles}
                                                        values={values}
                                                        setValues={setValues}
                                                        setTotalScore={setTotalScore}
                                                        totalScore={totalScore}
                                                        disabled={!values.wishToAddRiskProfile || isApiLoading}
                                                    />
                                                    <Box component={'section'} style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', gap: '20px', flexWrap: 'wrap' }}>
                                                        <Box sx={{ backgroundColor: `${theme.palette.success[500]}`, padding: '10px 20px', borderRadius: '5px' }}>
                                                            <Typography
                                                                sx={{
                                                                    color: '#FFF',
                                                                    fontWeight: 500,
                                                                    fontSize: 16,
                                                                    letterSpacing: '0.2px',
                                                                    fontFamily: `${theme.typography.fontFamily}`
                                                                }}>{`Your total Score : ${manageTotal(values)}`}
                                                            </Typography>
                                                        </Box>
                                                        {Number(manageTotal(values)) > 0 && <Box sx={{ backgroundColor: `${theme.palette.warning[500]}`, padding: '10px 20px', borderRadius: '5px' }}>


                                                            {profiletext(Number(manageTotal(values)), profileData)}


                                                        </Box>}
                                                    </Box>
                                                </>)}
                                        </Grid>
                                        <Grid item xs={12} my={2}>
                                            <MFCheckbox
                                                name={`riskProfileDeclaration`}
                                                label={riskProfileDeclaration}
                                                sx={{
                                                    display: 'flex',
                                                    alignItems: 'flex-start',
                                                    color: `${theme.palette.text.primary}`,
                                                    "& :disabled": {
                                                        color: `${theme.palette.text.secondary}`,
                                                    }
                                                }}
                                                disabled={!values.wishToAddRiskProfile || isApiLoading}

                                            />
                                            <Grid container spacing={2} sx={{ mt: 2 }}>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    lg={6}>
                                                    <Button
                                                        fullWidth
                                                        sx={(theme: Theme) => ({
                                                            backgroundColor: "transparent",
                                                            color: theme.palette.text.secondary,
                                                            border: `0.5px solid ${theme.palette.text.secondary}`,
                                                            borderRadius: "10px",
                                                            padding: "10px",
                                                            "&:hover, &.Mui-focusVisible": {
                                                                borderColor: theme.palette.text.secondary,
                                                                backgroundColor: theme.palette.background.default
                                                            }
                                                        })}
                                                        onClick={() => history.goBack()}
                                                    >
                                                        Cancel
                                                    </Button>
                                                </Grid>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    lg={6}
                                                    mt={{ xs: 2, lg: 0 }}

                                                >
                                                    {/* <LoadingButton
                                                        variant="contained"
                                                        fullWidth
                                                        sx={(theme) => ({
                                                            padding: "10px",
                                                            borderRadius: "10px",
                                                            backgroundColor: theme.palette.primary[500],
                                                            color: theme.palette.textDark.primary
                                                        })}
                                                    >
                                                        Submit
                                                    </LoadingButton> */}
                                                    <MFSubmitButton
                                                        label="Submit"
                                                        loadingEnable={editLoading}
                                                        disabled={loading}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                    </Grid>

                                    <ConfirmationDialog
                                        message={`Skip Risk Profiling`}
                                        subMessage='Are you sure you do not wish to undergo the RISK Profiling ?'
                                        open={openPopup !== null}
                                        setOpen={() => {
                                            setOpenPopup(null);
                                        }}
                                        onSave={() => {
                                            setValues({
                                                ...values,
                                                wishToAddRiskProfile: openPopup?.riskProfileCheck as boolean,
                                                riskProfileDeclaration: false,
                                                riskprofiles: values.riskprofiles?.map((_profile) => {
                                                    return {
                                                        ..._profile,
                                                        answer: '',
                                                        scoreText: '',
                                                        InvestmentGoal: [],
                                                        scoreCal: 0,
                                                    };
                                                }),
                                            });
                                            setOpenPopup(null);
                                        }}
                                        onCancel={() => {
                                            setOpenPopup(null);
                                        }}
                                        showIcon
                                    />
                                </Grid>
                            </Form>

                        )}
                    </Formik>
                </Box>
            </Box>
            <Dialog
                aria-labelledby="success-dialog"
                open={isSuccessDialogOpen}
                PaperProps={{
                    sx: (theme: Theme) => ({
                        maxWidth: '550px',
                        width: "100%",
                        borderRadius: "12px",
                        padding: "24px",
                        backgroundColor: theme.palette.common.white
                    }),
                }}
            >
                <DialogContent
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        rowGap: "12px",
                        padding: "15px",
                        overflow: "hidden"
                    }}
                >
                    <SuccessIcon />
                    <Typography
                        variant="h2"
                        sx={(theme: Theme) => ({
                            lineHeight: "25px",
                            letterSpacing: "0.01px",
                            color: theme.palette.text.primary
                        })}
                    >
                        Success!
                    </Typography>
                    <Typography
                        variant="subtitle_400"
                        sx={(theme: Theme) => ({
                            lineHeight: "22px",
                            letterSpacing: "0.02px",
                            color: theme.palette.text.secondary,
                            textAlign: "center",
                            paddingLeft: "10px",
                            paddingRight: "10px"
                        })}
                    >
                        Risk Profile edited successfully!!
                    </Typography>
                </DialogContent>
                <DialogActions
                    sx={{
                        padding: "0px",
                        marginTop: "40px",
                    }}
                >
                    <Button
                        fullWidth
                        variant="contained"
                        onClick={handleSuccessDialogClose}
                        sx={(theme: Theme) => ({
                            ...theme.typography.body_500,
                            fontWeight: 600,
                            lineHeight: "20px",
                            color: theme.palette.common.white,
                            borderRadius: "4px",
                            padding: "13px 20px",
                            backgroundColor: theme.palette.primary[500]
                        })}
                    >
                        OK
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog
                aria-labelledby="error-dialog"
                open={isErrorDialogOpen}
                PaperProps={{
                    sx: (theme: Theme) => ({
                        maxWidth: '550px',
                        width: "100%",
                        borderRadius: "12px",
                        padding: "24px",
                        backgroundColor: theme.palette.common.white
                    }),
                }}
            >
                <DialogContent
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        rowGap: "12px",
                        padding: "15px",
                        overflow: "hidden"
                    }}
                >
                    <FailureIcon width="35" height="35" />
                    <Typography
                        variant="h2"
                        sx={(theme: Theme) => ({
                            lineHeight: "25px",
                            letterSpacing: "0.01px",
                            color: theme.palette.text.primary
                        })}
                    >
                        Error!
                    </Typography>
                    <Typography
                        variant="subtitle_400"
                        sx={(theme: Theme) => ({
                            lineHeight: "22px",
                            letterSpacing: "0.02px",
                            color: theme.palette.text.secondary,
                            textAlign: "center",
                            paddingLeft: "10px",
                            paddingRight: "10px"
                        })}
                    >
                        Failed to edit the risk profile!!
                    </Typography>
                </DialogContent>
                <DialogActions
                    sx={{
                        padding: "0px",
                        marginTop: "40px",
                    }}
                >
                    <Button
                        fullWidth
                        variant="contained"
                        onClick={handleErrorDialogClose}
                        sx={(theme: Theme) => ({
                            ...theme.typography.body_500,
                            fontWeight: 600,
                            lineHeight: "20px",
                            color: theme.palette.common.white,
                            borderRadius: "4px",
                            padding: "13px 20px",
                            backgroundColor: theme.palette.primary[500]
                        })}
                    >
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
        </>

    );
}
